import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import styles from "./style.module.css";
import CloseIcon from "@mui/icons-material/Close";
import Switch from "../../ui/CustomSwitch";

interface PlayerCardProps {
  player: any;
  cardClose: () => void;
}
const useStyles = makeStyles({
  card: {
    display: "flex",
    width: "100%", //'213px',
    padding: "24px 16px 32px 16px",
    flexDirection: "column",
    alignItems: "center",
    gap: "24px",
    fontWeight: "500",
    backgroundColor: "inherit !important",
  },
  closeIcon: {
    position: "absolute",
    top: "8px",
    right: "8px",
    cursor: "pointer",
    color: "#777",
  },
});

const PlayerCard: React.FC<PlayerCardProps> = ({ player, cardClose }) => {
  const navigate = useNavigate();
  const classes = useStyles();
  const [isToggled, setIsToggled] = useState<boolean>(false);
  const handleClick = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    event.stopPropagation();
    const target = event.target as HTMLElement;
    if (!target.closest(".MuiSwitch-root")) {
      navigate(`/player/${player.playerId}`);
    }
  };

  return (
    <Card className={classes.card}>
      <CardContent className={styles.cardContent} onClick={handleClick}>
        <div className={styles.cardTitle}>
          <img src="https://cdn5.wyscout.com/photos/team/public/786_120x120.png" className={styles.teamLogo} alt="Icon" />
          <div className={styles.FWD}>FWD</div>
          <div className={styles.switch}>
            <div className="div-6">Map</div>
            <Switch
              id="test-switch"
              toggled={isToggled}
              // onChange={toggleTheme}
              source="Sidebar"
              isByComparison={false}
              onChange={(e) => setIsToggled(e.target.checked)}
            />
            <CloseIcon className={classes.closeIcon} onClick={cardClose} /> {/* Close icon */}
          </div>
        </div>
        <div className={styles.content}>
          <Typography className={styles.cardKey}>PlayerId</Typography>
          <Typography className={styles.cardValue}>{player.playerId}</Typography>
        </div>
        <div className={styles.content}>
          <Typography className={styles.cardKey}>SYSTEM FIT</Typography>
          <Typography className={styles.cardValue}>65%</Typography>
        </div>
        <div className={styles.content}>
          <Typography className={styles.cardKey}>AGE</Typography>
          <Typography className={styles.cardValue}>20</Typography>
        </div>
        <div className={styles.content}>
          <Typography className={styles.cardKey}>TRUE VALUE</Typography>
          <Typography className={styles.cardValue}>2.1m</Typography>
        </div>
        <div className={styles.content}>
          <Typography className={styles.cardKey}>WAGES PW</Typography>
          <Typography className={styles.cardValue}>50,000</Typography>
        </div>
        <div className={styles.content}>
          <Typography className={styles.cardKey}>CONTRACT END</Typography>
          <Typography className={styles.cardValue}>SEPT 2026</Typography>
        </div>
      </CardContent>
    </Card>
  );
};

export default PlayerCard;
